import React from "react";
import { Badge } from "antd";
import { FormattedMessage } from "react-intl";

const ActiveComponent = (props) => {
  const { record, category } = props;
  return (
    <Badge
      status={record.active ? "success" : "error"}
      text={
        record.active ? (
          <FormattedMessage id={"app." + category + ".activated"} />
        ) : (
          <FormattedMessage id={"app." + category + ".frozen"} />
        )
      }
    />
  );
};

export default ActiveComponent;
